import * as _ from 'lodash-es';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { EventData } from '@repo/core/models';
import { ref } from 'vue';
import { useRootStore } from './root.store';

export const useEventStore = defineStore('event', () => {
  // state
  const eventData = ref<EventData>({} as EventData);

  // actions
  const setEventData = (data: EventData) => {
    eventData.value = { ...data };
  };

  // Sync the client context carried on an inbound parent message into the root
  // store. Tenancy ids (practice/client/entity/financialYear) are NON-destructive:
  // a missing header (periodic tokenRenewed, a stale retry, a multi-tab mismatch)
  // must NOT clobber an established value, or it would strip the tenancy headers
  // off every subsequent API call. Explicit clears go through rootStore.clearCurrent*().
  // supportAccessRequestId is intentionally MESSAGE-DRIVEN: omission is how the shell
  // ends a support session, so a stale id must not linger (it would keep elevated access alive).
  const setContext = (data: Partial<EventData>) => {
    const rootStore = useRootStore();
    if (!_.isEmpty(data.practiceId)) rootStore.practiceId = _.toLower(data.practiceId);
    if (!_.isEmpty(data.clientId)) rootStore.clientId = _.toLower(data.clientId);
    if (!_.isEmpty(data.entityId)) rootStore.entityId = _.toLower(data.entityId);
    if (!_.isEmpty(data.financialYearId)) rootStore.financialYearId = _.toLower(data.financialYearId);
    rootStore.supportAccessRequestId = _.toLower(data.supportAccessRequestId);
  };

  const state = { eventData };
  const actions = { setEventData, setContext };

  return { ...state, ...actions };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEventStore, import.meta.hot));
}
